"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * This function compares Version number of companion
 * return 1 if v1>v2, -1 if v1<v2, 0 if v1==v2
 */
function compareVersion(v1, v2) {
    function isString(s) {
        return (typeof s === 'string' || s instanceof String);
    }
    if (!isString(v1) || !isString(v2)) {
        return undefined;
    }
    var v1parts = v1.split('.');
    var v2parts = v2.split('.');
    for (var i = 0; i < v1parts.length; ++i) {
        if (v2parts.length === i) {
            return 1;
        }
        if (parseInt(v1parts[i], 10) === parseInt(v2parts[i], 10)) {
            continue;
        }
        if (parseInt(v1parts[i], 10) > parseInt(v2parts[i], 10)) {
            return 1;
        }
        return -1;
    }
    if (v1parts.length != v2parts.length) {
        return -1;
    }
    return 0;
}
function copyTextToClipboard(document, text) {
    var textArea = document.createElement("textarea");
    //
    // *** This styling is an extra step which is likely not required. ***
    //
    // Why is it here? To ensure:
    // 1. the element is able to have focus and selection.
    // 2. if element was to flash render it has minimal visual impact.
    // 3. less flakyness with selection and copying which **might** occur if
    //    the textarea element is not visible.
    //
    // The likelihood is the element won't even render, not even a flash,
    // so some of these are just precautions. However in IE the element
    // is visible whilst the popup box asking the user for permission for
    // the web page to copy to the clipboard.
    //
    textArea.id = 'copy-text-container';
    // Place in top-left corner of screen regardless of scroll position.
    textArea.style.position = 'fixed';
    textArea.style.top = '0';
    textArea.style.left = '0';
    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = '0';
    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    // Avoid flash of white box if rendered for any reason.
    textArea.style.background = 'transparent';
    textArea.value = text;
    var prevActiveElem = document.activeElement;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    var successful = false;
    try {
        successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Copying text command was ' + msg);
    }
    catch (err) {
        console.log('Oops, unable to copy');
    }
    document.body.removeChild(textArea);
    prevActiveElem.focus();
    return successful;
}
;
function isDevEnvironment(window) {
    return /^(127\.0\.0\.1|0\.0\.0\.0|localhost|.*\.corp\.amazon\.com)$/.test(window.location.hostname);
}
var util = {
    isDevEnvironment: isDevEnvironment,
    compareVersion: compareVersion,
    copyTextToClipboard: copyTextToClipboard
};
exports.default = util;
